import scrollToElement from "scroll-to-element";
import Swiper from "swiper";
// import tick from "../helpers/async";
const tick = require("../helpers/async")
import { setCSSCustomProperty } from "../helpers/css";
import wait from '../helpers/wait';

const isPage = slug => document.body.classList.contains(slug);

export const UIController = {
  init() {
    return new Promise((resolve, reject) => {
      try {
        this.initMeasurementCheckers();
        this.initContentTabs();
        this.initLazyVideos();
        this.initAnchorLinksScroller();
        this.checkStoredHash();
        this.initStackSlides();
        this.highlightCurrentPageLinks();
        this.setFavIcon();
        this.enhanceRingSizePicker();
        this.displayRingSizeChartLink();
        this.addSwatchSelectorHooks();
        this.recordNavBarHeight();
        // this.goBack();
        if (isPage('home')) {
          this.initHeroSlider();
        }
        // this.initSlideshareIFrames();
        if (isPage('single') || isPage('page-template-page')) {
          this.initPostGridSwiper();
          
        }
        this.initGallerySlider();

        resolve();
      } catch (error) {
        reject(error);
      }
    })
  },

  goBack() {
    window.history.back();
  },

  recordWindowDimensions() {
    const { innerWidth, innerHeight } = window;
    setCSSCustomProperty('--vw', innerWidth + 'px');
    setCSSCustomProperty('--vh', innerHeight + 'px');
  },
  recordWpAdminBarHeight() {
    const el = document.getElementById('wpadminbar');
    const height = el ? el.clientHeight : 0;
    setCSSCustomProperty('--wp-admin-bar-height', height + 'px');
    return height;
  },
  recordNavBarHeight() {
    const el = document.querySelector('.section-site-nav');
    const height = el ? el.clientHeight : 0;
    setCSSCustomProperty('--nav-height', height + 'px');
    return height;
  },
  recordNavSearchBarHeight() {
    const el = document.querySelector('.search-form-wrapper');
    const height = el ? el.clientHeight : 0;
    setCSSCustomProperty('--nav-search-form-height', height + 'px');
    return height;
  },
  recordContentTabsHeight() {
    const el = document.querySelector('.section-content-tabs');
    const height = el ? el.clientHeight : 0;
    setCSSCustomProperty('--content-tabs-height', height + 'px');
    return height;
  },
  recordHeaderHeight() {
    const el = document.querySelector('.woocommerce-products__header') || document.querySelector('.standard-page__header') || document.querySelector('.gallery__header');
    const height = el ? el.clientHeight : 0;
    setCSSCustomProperty('--page-header-height', height + 'px');
    return height;
  },
  initMeasurementCheckers() {
    const handleWindowLoad = () => {
      this.recordWindowDimensions();
      this.recordWpAdminBarHeight();
      this.recordNavBarHeight();
      this.recordNavSearchBarHeight();
      this.recordHeaderHeight();
    }
    const handleWindowResize = () => {
      this.recordWindowDimensions();
      this.recordWpAdminBarHeight();
      this.recordNavBarHeight();
      this.recordNavSearchBarHeight();
      this.recordHeaderHeight();
    }
    window.addEventListener('load', handleWindowLoad);
    // window.addEventListener('scroll', handleWindowLoad);
    window.addEventListener('resize', handleWindowResize);
  },
  initAnchorLinksScroller() {
    const els = document.querySelectorAll('.section-nav a[href*="#"], .view-main a[href*="#"]');
    const handler = e => {
      try {
        const { target } = e;
        const href = target.getAttribute('href');
        const match = href.match(/([^#]*)#(.*)/);
        if (!match) return;
        const pathname = match[1];
        // console.log(match, pathname, window.location.pathname, pathname !== window.location.pathname);
        if (!!pathname && pathname !== window.location.pathname) return;
        // do not do anything if the thing links to a different page
        const id = match[2];
        if (!id) return;
        // only prevent default if an id is found
        e.preventDefault();
        this.scrollToId(id); 
      } catch(e) {
        console.error(e);
        return;
      }
    };
    Array.from(els).forEach(el => {
      el.addEventListener('click', handler);
    })
  },
  async checkStoredHash() {
    if (window.ID_HASH) {
      await wait(500);
      this.scrollToId(window.ID_HASH);
      await wait(618);
      window.location.hash = window.ID_HASH;
    }
  },
  scrollToId(id) {
    if (!id) this.scrollToTop();
    else {
      const offset = -1 * (
        this.recordWpAdminBarHeight() + 
        this.recordNavBarHeight() +
        this.recordContentTabsHeight()
      );
      scrollToElement('#' + id, { offset, ease: 'inOutCube', duration: 618 });
    }
  },
  scrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  },
  getSiteTitle() {
    return document.body.getAttribute('data-site-title');
  },
  getPageTitle() {
    const titleEl = document.querySelector('.page-header__title') || document.querySelector('h1') || document.querySelector('title');
    const title = titleEl && titleEl.innerText;
    return title || '';
  },
  initContentTabs() {
    const el = document.querySelector('.section-content-tabs');
    if (!el) return;
    const makeTab = (title, url, active) => `<li><a class="content-tab${active && ' active'}" href="${url}" title="${title}">${title}</a></li>`
    const tabSourceEls = Array.from(document.querySelectorAll('[data-content-tab-id]'));
    tabSourceEls.forEach(el => el.setAttribute('id', el.getAttribute('data-content-tab-id')))
    const tabs = tabSourceEls.map(el => makeTab(
      el.getAttribute('data-content-tab-title'),
      '#' + el.getAttribute('data-content-tab-id'),
    ));
    const pageTitle = this.getPageTitle();
    const hasHashOnLoad = !!window.location.hash;
    tabs.unshift(makeTab(pageTitle, '#', !hasHashOnLoad));
    el.querySelector('ul').innerHTML = tabs.join('');
    const anchors = Array.from(el.querySelectorAll('a'));
    const setActive = e => {
      anchors.forEach(a => a.classList.remove('active'));
      const { target } = e;
      target.classList.add('active');
    }
    anchors.forEach(a => a.addEventListener('click', setActive));
  },
  initPostGridSwiper() {

    const grid = document.querySelector('.post-grid');
    if (!grid) return;
    const postItems = grid.querySelectorAll('.post-item');

    const container = document.createElement('div');
    container.classList.add('post-grid-swiper');
    container.classList.add('swiper-container');

    const wrapper = document.createElement('div');
    wrapper.classList.add('swiper-wrapper');

    const slides = Array.from(postItems).map(postItem => {
      const slideContainer = document.createElement('div');
      slideContainer.classList.add('swiper-slide');
      slideContainer.append(postItem);
      return slideContainer;
    });

    wrapper.append(...slides);
    container.append(wrapper);
    grid.replaceWith(container);

    // new Swiper(container, {
    //   slidesPerView: 1.5,
    //   centeredSlides: true,
    //   loop: true,
    //   slideToClickedSlide: true,
    //   autoplay: {
    //     delay: 4000,
    //   },
    //   // breakpoints: {
    //   //   768: {
    //   //     slidesPerView: 3,
    //   //   }
    //   // }
    // });

  },
  initStackSlides() {
    const stack = document.querySelector('.section-stack-container');
    if (!stack) return;
    const allCards = Array.from(document.querySelectorAll('.section-stack-card'));
    let currentSlideId = 0;
    const goToSlide = n => {
      currentSlideId = n;
      allCards.forEach(c => c.classList.remove('active'));
      allCards[n].classList.add('active');
    }
    const onNext = () => {
      if (currentSlideId < 2) currentSlideId++;
      else currentSlideId = 0;
      goToSlide(currentSlideId);
    }
    const onPrev = () => {
      if (currentSlideId > 0) currentSlideId--;
      else currentSlideId = 2;
      goToSlide(currentSlideId);
    }
    document.querySelector('.section-stack-nav__next-button').addEventListener('click', onNext);
    document.querySelector('.section-stack-nav__prev-button').addEventListener('click', onPrev);
    allCards.forEach((c, i) => c.querySelector('.section-stack-card-inner').addEventListener('click', () => {
      if (i === currentSlideId) return;
      goToSlide(i);
    }))
  },
  detectRatio(el) {
    if (!el) return;
    const w = el.clientWidth;
    const h = el.clientHeight;
    const ratio = w / h;
    const orientation = ratio >= 1 ? 'landscape' : 'portrait';
    el.setAttribute('data-element-width', w + 'px');
    el.setAttribute('data-element-height', h + 'px');
    el.setAttribute('data-element-ratio', ratio);
    el.setAttribute('data-element-orientation', orientation);
    setCSSCustomProperty('--element-width', w + 'px', el);
    setCSSCustomProperty('--element-height', h + 'px', el);
    setCSSCustomProperty('--element-ratio', ratio, el);
    setCSSCustomProperty('--element-orientation', orientation, el);
  },
  initLazyVideos() {

    var lazyVideos = [].slice.call(document.querySelectorAll("video.lazy"));

    if ("IntersectionObserver" in window) {
      var lazyVideoObserver = new IntersectionObserver(function (entries, observer) {
        entries.forEach(video => {
          if (video.isIntersecting) {
            for (var source in video.target.children) {
              var videoSource = video.target.children[source];
              if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
                videoSource.src = videoSource.dataset.src;
              }
            }

            video.target.load();
            video.target.classList.remove("lazy");
            lazyVideoObserver.unobserve(video.target);
          }
        });
      });

      lazyVideos.forEach(function (lazyVideo) {
        lazyVideoObserver.observe(lazyVideo);
      });
    }

    this.initRatioWatcher();
    this.initVideoCoverer();

  },
  initRatioWatcher() {
    const els = document.querySelectorAll('[data-watch-ratio]');
    Array.from(els).forEach(el => {
      const handler = () => this.detectRatio(el);
      window.addEventListener('load', handler);
      window.addEventListener('resize', handler);
    });
  },
  initVideoCoverer() {
    const handler = () => {
      const videoSlides = document.querySelectorAll('.section-hero-banner');
      Array.from(videoSlides).forEach(slide => {
        const video = slide.querySelector('video');
        const checkVideoRatio = () => {
          const videoWidth = video.videoWidth;
          const videoHeight = video.videoHeight;
          const videoRatio = videoWidth / videoHeight;
          const containerWidth = slide.clientWidth;
          const containerHeight = slide.clientHeight;
          const containerRatio = containerWidth / containerHeight;
          if (videoRatio >= containerRatio) {
            // video is wider or square; 100% height and auto width.
            video.setAttribute('data-fill-mode', 'fill-height');
          } else {
            video.setAttribute('data-fill-mode', 'fill-width');
          }
        };
        checkVideoRatio();
      })
    }
    window.addEventListener('load', handler);
    window.addEventListener('resize', handler);
  },
  initHeroSlider() {
    const slides = document.querySelectorAll('.hero-banner-slides .swiper-slide');
    if (slides.length === 1) return;
    new Swiper('.hero-banner-slides', {
      loop: true,
      slidesPerView: 1,
      spaceBetween: 0,
      // navigation: {
      //   nextEl: '.swiper-button-next',
      //   prevEl: '.swiper-button-prev',
      // },
    });
  },

  initGallerySlider() {
    const galleryThumbs = new Swiper('.gallery-thumbs', {
      spaceBetween: 10,
      slidesPerView: 5,
      loop: true,
      freeMode: true,
      loopedSlides: 5, //looped slides should be the same
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
    });
    const galleryTop = new Swiper('.gallery-top', {
      spaceBetween: 10,
      loop:true,
      loopedSlides: 5, //looped slides should be the same
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      thumbs: {
        swiper: galleryThumbs,
      },
    });
  },

  highlightCurrentPageLinks() {
    const { origin, pathname } = window.location;
    const originRegExp = new RegExp('^' + origin);
    const anchors = document.querySelectorAll('a');
    const pathnameRegExp = new RegExp('^' + pathname);
    Array.from(anchors).forEach(a => {
      if (a.href) {
        const i = a.href.replace(originRegExp, '');
        const matches = a.classList.contains('fuzzy-match') ? i.match(pathnameRegExp) : i === pathname;
        // console.log(i, pathname, matches);
        if (matches) a.classList.add('active');
      }
    })
  },
  listenForFirstImageLoad() {
    return new Promise((resolve, reject) => {
      const firstImage = document.querySelector('.woocommerce-product-gallery__image img');
      if (!firstImage) reject('No product image found.');
      if (firstImage.complete) {
        if (firstImage.naturalHeight !== 0) {
          resolve(firstImage);
        } else {
          reject('First image not valid');
        }
      } else {
        firstImage.addEventListener('load', e => {
          // console.log('image loaded');
          resolve(firstImage);
        });
        firstImage.addEventListener('error', e => {
          reject(e);
        })
      }
    })
  },
  async setFavIcon() {
    try {
      const imageEl = await this.listenForFirstImageLoad();
      const favIcons = document.querySelectorAll('link[rel="icon"]');
      const src = imageEl.getAttribute('data-src');
      if (!src) return;
      Array.from(favIcons).forEach(icon => icon.href = src);
    } catch (e) {
      console.warn(e);
    }
  },
  enhanceRingSizePicker() {
    
    const picker = document.getElementById('pa_ring-size');
    if (!picker) return;
    const form = document.querySelector('form.cart');
    picker.addEventListener('change', e => console.log(e));
    const options = Array.from(picker.children).filter(c => c.nodeName === 'OPTION'); 

    const customPicker = document.createElement('div');
    customPicker.classList.add('custom-dropdown');
    customPicker.setAttribute('data-mirror-select-id', 'pa_ring-size');

    const customPickerSelectionDisplay = document.createElement('button');
    customPickerSelectionDisplay.setAttribute('type', 'button');
    customPickerSelectionDisplay.classList.add('custom-dropdown__selected');
    customPickerSelectionDisplay.innerHTML = options.find(o => o.value === picker.value)?.innerHTML || '<span>Choose An Option</span>';
    customPicker.append(customPickerSelectionDisplay);

    const optionListWrapper = document.createElement('div');
    optionListWrapper.classList.add('custom-dropdown__list-wrapper');
    
    const optionList = document.createElement('div');
    optionList.classList.add('custom-dropdown__list');
    optionListWrapper.appendChild(optionList);

    const newOptionButtons = options.filter(o => !!o.value).map(o => {
      const newOption = document.createElement('button');
      newOption.innerHTML = `<span>${o.innerHTML}</span>`;
      newOption.addEventListener('click', () => {
        picker.value = o.value;
        jQuery(picker).change();
        customPickerSelectionDisplay.innerHTML = `<span>${o.innerHTML}</span>`;
        newOptionButtons.forEach(b => b.classList.remove('selected'));
        newOption.classList.add('selected');
      })
      newOption.setAttribute('type', 'button');
      return newOption;
    });
    optionList.append(...newOptionButtons);
    customPicker.append(optionListWrapper);

    const handleDocumentClickWhenOpen = e => {
      const { target } = e;
      if (target && customPicker.contains(target)) {
        closeDropdown();
      } else {
        e.preventDefault();
        closeDropdown();
      }
    }
    const openDropdown = async () => {
      customPicker.classList.add('open');
      await tick(100);
      document.addEventListener('click', handleDocumentClickWhenOpen);
    }
    const closeDropdown = () => {
      customPicker.classList.remove('open');
      document.removeEventListener('click', handleDocumentClickWhenOpen);
    }
    customPicker.addEventListener('click', () => {
      if (customPicker.classList.contains('open')) {
        closeDropdown();
      } else {
        openDropdown();
      }
    })

    picker.parentElement.insertBefore(customPicker, picker);
    picker.style.display = 'none';
  },
  async displayRingSizeChartLink() {
    const control = document.getElementById('pa_ring-size');
    const linkContainer = document.getElementById('ring-size-chart-link-container');
    if (control && linkContainer) {
      control.parentElement.appendChild(linkContainer);
      await tick();
      linkContainer.classList.remove('hidden');
    }
  },
  addSwatchSelectorHooks() {
    const select = document.getElementById('pa_stone');
    if (!select) return;
    const label = document.querySelector('[for="pa_stone"]');
    const swatches = document.querySelector('[data-attribute_name="attribute_pa_stone"]');
    const handler = e => {
      // console.log('pa_stone input event', select.value);
      if (select.value) {
        const swatch = document.querySelector(`[data-value="${select.value}"]`);
        label.innerHTML = `Stone: ${swatch ? swatch.getAttribute('title') : (select.value || '').replace('-', ' ')}`;
      } else {
        label.innerHTML = 'Stone: Please Select';
      }
    };
    handler();
    select.addEventListener('input', handler)
    if (swatches) {
      swatches.addEventListener('click', handler);
    }
  },
  initPopups() {

  }
}